<template>
  <div class="assessment_main">
    <div class="assessment_title">
      <h2>智能估值</h2>
    </div>
    <ul v-if="productFlag==3">
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappgz:mgy')">
        <img src="../img/mgy-logo.png" alt="" class="app_logo">
        <img src="../img/mgy-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('mgy')">进入系统</el-button>
      </li>
    </ul>
    <ul v-if="productFlag==4">
      <li v-if="isStudent||$_has('zledu.gxzx.zsrwappgz:mgy')">
        <img src="../img/mgy-logo.png" alt="" class="app_logo">
        <img src="../img/mgy-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('mgy')">进入系统</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto'
import * as userApi from '../../../../api/userApi'
export default {
  data() {
    return {
      sysUserPermissionList: JSON.parse(localStorage.getItem('sysUserPermissionList'))  || [], // 权限对象
      userType: sessionStorage.getItem('userType'), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem('productFlag'),
    };
  },
  created() {
    if(this.userType==2 || this.userType==3){
      this.isStudent = true
    }else{
      this.isStudent = false
    }
  },
  methods: {
    setSha1(url){//sha1加密
      const hmac = crypto.createHmac('sha1', '123456');
      hmac.update(url);
      return hmac.digest('hex')
    },
    entrySys(sys){
      // this.courseType  1 1+X平台、2 单项训练 3综合平台
      // this.productId   1 综合 2 单项
      // this.type        1、2 单项 3 综合
      // 状态判断
      // let status = false;
      // if (this.userType == 0){
      //   status = true;
      // }else{
      //   if (this.sysUserPermissionList && this.sysUserPermissionList.length){
      //     [].forEach.call(this.sysUserPermissionList, item =>{
      //         if (item.productId == 1) {
      //           if (this.userType == 1){
      //             if (item.teacherOnoff == true) {
      //               status = true;
      //             }
      //           }
      //           if (this.userType == 2){
      //             if (item.studentOnoff == true) {
      //               status = true;
      //             }
      //           }
      //         }
      //     })
      //   }else{
      //     status = false;
      //   }
      // }
      // if (!status) {
      //   this.$messageWarning("没有开通权限");
      //   return false;
      // }
      if(localStorage.getItem('Authorization')){
        userApi.isExpired(localStorage.getItem('Authorization')).then(rs=>{
          if(rs.code==0 && rs.data==0){
            if(sys=='mgy'){
              let userType = sessionStorage.getItem('userType')
              // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
              //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
              //   this.loading = false
              //   return
              // }
              var tmpWin = window.open()
              tmpWin.document.open();
              tmpWin.document.write("跳转中，请稍后。。。");
              tmpWin.document.close();

              let phone = sessionStorage.getItem('mobile')
              let name = sessionStorage.getItem('loginName')
              let schoolId = sessionStorage.getItem('deptId')
              let schoolName = sessionStorage.getItem('deptName')
              let time = new Date().getTime() +""
              let userId = sessionStorage.getItem('userId')

              let url = 'mobile='+phone+'&model=tm&nickName='+name+'&platform='+sys+'&schoolId='+schoolId+'&schoolName='+schoolName+'&templateCode=&time='+time+'&userId='+userId
              let sha1sign = this.setSha1(url)
              let stxObj = {
                mobile: phone,
                nickName: name,
                platform: sys,
                schoolId: schoolId,
                schoolName: schoolName,
                templateCode: '',
                time: time,
                userId: userId,
                userType: userType,
                model: 'tm',
                sign: sha1sign,
                examType: 3
              }
              axios.post(process.env.apply_MGY_API,qs.stringify(stxObj)).then(res=>{
                if(res.data.result){
                  tmpWin.location = res.data.value
                  this.loading = false
                }else{
                  this.$messageError(res.data.error.message)
                  tmpWin.document.open();
                  tmpWin.document.write(res.data.error.message);
                  tmpWin.document.close();
                  this.loading = false
                }
              }).catch(err=>{
                tmpWin.document.open();
                if(err.code == '401'){
                  tmpWin.document.write("登录已过期，请重新登录");
                  tmpWin.location.href = process.env.BASE_API
                }else{
                  tmpWin.document.write("接口访问异常"+err.code);
                }
                tmpWin.document.close();
                this.loading = false
              })
            }else{
              this.loading = false
              this.$messageWarning('暂无权限，请联系管理员！')
            }
          }else{
            this.$router.push({path:'/'})
            this.$messageError('登录已过期，请重新登录')
            localStorage.removeItem('Authorization')
            localStorage.removeItem('isbinding')
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        this.loading = false
        this.$router.push({path:'/home'})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.assessment_main{
  .assessment_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      width:278px;
      height:180px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 8px rgba(0,0,0,0.16);
      border-radius:4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo{
        position: absolute;
        left: 40px;
        top: 48px;
        z-index: 2;
        height: 22px;
      }
      .app_bg{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width:278px;
        height:180px;
      }
      button{
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width:96px;
        height:34px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(83,151,247,1);
        border-radius:4px;
        padding: 0;
        color: #5397F7;
        &:hover{
          background: #5397F7;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/valuation.vue